/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Testimonials from '../components/Testimonials';
import OpenTime from '../components/OpenTime';
import ConnectedAlertLink from '../components/ConnectedCookieConsent/ConnectedAlertLink'
import Fade from 'react-reveal/Fade'
import ImagesCarousel from '../components/ImagesCarousel';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Img from "gatsby-image";
import UbHome from "./../img/UbHome"
import Ub from "./../img/Ub"
import SvgEl from "./../components/SvgEl"
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'

const bowser = require('bowser');

// Messages
import de from '../i18n/de.json'
import en from '../i18n/en.json'
import ru from '../i18n/ru.json'

const messages = { de, en, ru }

export const PageTemplate = ({
                                     title,
                                     templateKey,
                                     heading,
                                     description,
                                     meta_title,
                                     meta_description,
                                     language,
                                     closingDay,
                                     dayOn,
                                     dayOff,
                                     grid,
                                     page_heading,
                                     text,
                                     text1,
                                     browserDataName,
                                     browserSafari,
                                     osDataName

                                 }) => (
    <div>
        <Helmet
        bodyAttributes={{
            class: templateKey + ' dct-' + browserDataName + ' dct-' + osDataName +  browserSafari
        }}
        >
            <html lang={language} />
            <title>{meta_title}</title>
            <meta name="description" content={meta_description}/>
        </Helmet>

        <Fade>

        <section>
        <div className="columns">
            <div className="column is-10 is-offset-1 has-margin-top-2">
                <h1 className="title title-section is-size-1 has-text-centered sand-dark" dangerouslySetInnerHTML={{ __html: page_heading }}/>
                <h2 className="title-sub is-size-3 has-text-centered" dangerouslySetInnerHTML={{ __html: heading }}/>
        </div>
        </div>
        </section>


      {/*  <section>
       <div className="img_carousel">
        <ImagesCarousel autoPlay={false} data={grid}/>
        </div>
        </section>
        */}
        <section className="section section--gradient bg-sand">
            <div className="container">
              <div className="column is-10 is-offset-1 has-text-centered">
              <img className="portrait-circle" src = "/static/remi-blot-1.jpg" alt="Rémi Blot Digital agency"/>
              <div className="has-text-centered"><strong>Rémi Blot</strong><br/>Founder</div>
              </div>
                    <div className="columns">
                        <div className="column is-10 is-offset-1">
                      <div className="eu-dsgvo" dangerouslySetInnerHTML={{ __html: remark().use(recommended).use(remarkHtml).processSync(text).toString()}}/>

                      </div>


                    </div>
            </div>
        </section>

        </Fade>

    </div>
);

PageTemplate.propTypes = {
    title: PropTypes.string,
    closingDay: PropTypes.number,
    dayOn: PropTypes.string,
    dayOff: PropTypes.string,
    meta_title: PropTypes.string,
    meta_description: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.string,
    text1: PropTypes.string,
    grid: PropTypes.object,
    page_heading: PropTypes.string

};

class Page extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      browserData: '',
      osData: ''
    };
  }

  componentDidMount() {
    const browser = bowser.getParser(window.navigator.userAgent);
    const browserData = browser.parsedResult.browser;
    const osData = browser.parsedResult.os;
    this.setState({
      browserData: browserData,
      osData: osData
    })
  }

  render() {

    const {frontmatter} = this.props.data.markdownRemark;
    const {siteMetadata} = this.props.data.site;


    return (
        <PageTemplate
            title={frontmatter.title}
            meta_title={frontmatter.meta_title}
            templateKey={frontmatter.templateKey}
            browserDataName={this.state.browserData.name}
            osDataName={this.state.osData.name}
            browserSafari={this.state.browserData.name !== 'Safari' ? ' dct-not-Safari' : ''}
            meta_description={frontmatter.meta_description}
            heading={frontmatter.heading}
            description={frontmatter.description}
            language={frontmatter.language}
            closingDay={siteMetadata.closingDay}
            dayOn={siteMetadata.dayOn}
            dayOff={siteMetadata.dayOff}
            text={frontmatter.text}
            text1={frontmatter.text1}
            grid={this.props.data}
            page_heading={frontmatter.page_heading}
        />
    )

  }



}

Page.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.object,
            siteMetadata: PropTypes.object
        }),
    }),
};

export default Page

export const pageQuery = graphql`
  query aboutMePage($id: String!) {
    site {
      siteMetadata {
        title
        dayOn
        dayOff
        closingDay
      }
    }
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        meta_title
        templateKey
        meta_description
        page_heading
        heading
        description
        text
        text1
        language
        carousel {
          image{
            src
            title
            sub_headline
            slug
          }
        }

      }
    }
    carouselPicts: allImageSharp(
      filter: { id: { regex: "/images/kontakt-carousel/" } },
      sort: { order: ASC, fields: [id]}

    ) {
      edges {
        node {
          sizes(maxWidth: 1800,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }

  }
`;



// WEBPACK FOOTER //
// ./src/templates/page-about.js